import { createFileRoute, notFound } from '@tanstack/react-router';
import { type ViewParam, isValidView, type SubnavParam, type TypeParam, isValidSubNav, isValidType } from './-utils';

type SearchParams = {
  seedId?: string;
  copyAudience?: boolean;
  templateId?: string;
  isSystemTemplate?: boolean;
  isEdit?: boolean;
};

type Params = {
  view: ViewParam;
  subNav: SubnavParam;
  type: TypeParam;
  id: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/bulk_/$subNav_/$type_/$id_/$view')({
  params: {
    parse: (params): Params => {
      if (!isValidType(params.type)) {
        throw notFound();
      }
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      if (!params.id) {
        throw notFound();
      }
      if (!isValidView(params.view)) {
        throw notFound();
      }
      return {
        ...params,
        id: params.id,
        subNav: params.subNav,
        type: params.type,
        view: params.view,
      };
    },
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    return {
      seedId: search.seedId,
      copyAudience: search.copyAudience,
      templateId: search.templateId,
      isSystemTemplate: search.isSystemTemplate,
      isEdit: search.isEdit,
    };
  },
});
